import useAxios from "../../hooks/useAxios";

const useEmployeeService = () => {
  const axiosGetAllEmployees = useAxios();
  const axiosAddEmployee = useAxios();
  const axiosEditEmployee = useAxios();
  const axiosAddBulkEmployees = useAxios();

  const getAllEmployees = async (search) => {
    const query = search ? `?search=${encodeURIComponent(search)}` : "";
    await axiosGetAllEmployees.fetchData({
      url: `/admin/employee${query}`,
      method: "GET",
    });
  };

  const addEmployee = async (data) => {
    const result = await axiosAddEmployee.fetchData({
      url: `/admin/employee/add`,
      method: "POST",
      data,
    });
    return result;
  };

  const editEmployee = async (data) => {
    const result = await axiosEditEmployee.fetchData({
      url: `/admin/employee/edit`,
      method: "POST",
      data,
    });
    return result;
  };

  const addEmployeesBulk = async (data) => {
    const result = await axiosAddBulkEmployees.fetchData({
      url: `/admin/employee/add-bulk`,
      method: "POST",
      data,
    });
    return result;
  };

  return {
    // list
    getAllEmployees,
    employeeLoading: axiosGetAllEmployees.loading,
    employeeResponse: axiosGetAllEmployees.response,

    // add
    addEmployee,
    addEmployeeLoading: axiosAddEmployee.loading,
    addEmployeeResponse: axiosAddEmployee.response,

    // edit
    editEmployee,
    editEmployeeLoading: axiosEditEmployee.loading,
    editEmployeeResponse: axiosEditEmployee.response,

    // bulk add
    addEmployeesBulk,
    addEmployeesBulkLoading: axiosAddBulkEmployees.loading,
    addEmployeesBulkResponse: axiosAddBulkEmployees.response,
  };
};

export default useEmployeeService;
